@if (pageReady) {
  <main class="gs-page">
    <div class="autopay-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        @if (changeAutoPay) {
          <p>{{ this.pageLabels.changeAutoPayEnrollText }}</p>
        } @else {
          <p>{{ pageLabels.description }}</p>
        }
        <form class="autopay-form" [formGroup]="autopayForm">
          <div class="pay-method">
            <h2>{{ pageLabels.payMethodInputHeader }}</h2>
            <mat-form-field class="payment-list" appearance="outline" color="primary">
              <mat-label>{{ pageLabels.payMethodLabel }}</mat-label>
              <mat-select formControlName="paymethod" (selectionChange)="paymethodChanged()">
                @for (method of paymethods; track method) {
                  <mat-option class="paymethod-option" [value]="method">
                    {{ method.Nickname ? method.Nickname : method.Description }}
                    @if (method.IsExpired) {
                      <span class="paymethod-expired">{{ pageLabels.payMethodExpiredText }}</span>
                    }
                  </mat-option>
                }
              </mat-select>
              @if (autopayForm.get("paymethod")?.hasError("required")) {
                <mat-error id="payMethodReqError">{{ pageLabels.payMethodRequiredError }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="terms-container">
            <mat-checkbox color="primary" formControlName="terms"
              >{{ pageLabels.termsConditionsText }}
              <a href="{{ pageLabels.termsConditionsLinkUrl }}" target="_blank" rel="noopener noreferrer"
                >{{ pageLabels.termsConditionsLinkText }}<span class="cdk-visually-hidden"> (opens in new tab)</span>
                <i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square"></i
              ></a>
            </mat-checkbox>
            @if (autopayForm.get("terms")?.touched && autopayForm.get("terms")?.hasError("required")) {
              <mat-error id="termConditionsError" class="gs-error terms-conditoins-error">{{
                pageLabels.termsRequiredError
              }}</mat-error>
            }
          </div>
          @if (!hasEmail) {
            <div class="email-form pay-detail">
              <h2>{{ pageLabels.emailHeader }}</h2>
              <app-email-form [emailData]="emailFormData"></app-email-form>
              <p class="email-disclaimer">{{ pageLabels.emailDisclaimer }}</p>
            </div>
          }
          <div class="button-container">
            <button
              role="link"
              class="gs-form-button-primary"
              mat-flat-button
              color="primary"
              (click)="enrollAutopay()"
            >
              {{ pageLabels.enrollCtaBtnText }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>
}
